import { generateStripeState } from '../helper'

const options = {
  api: {
    list: () => `/api/stripe/customers`,
    delete: ({ id }) => `/api/stripe/customer/${id}`,
    update: ({ id }) => `/api/stripe/customer/${id}`,
    // NOTE: This is not a stripe route; It does create a stripe customer though
    create: () => `/api/customer`,
    get: ({ id }) => `/api/stripe/customer/${id}`,
  },
  state: {
    collectionName: 'customers'
  },
  getters: {
    getPagination: 'getCustomerPagination',
    getCollection: 'getCustomers'
  },
  actions: {
    list: 'listCustomers',
    delete: 'deleteCustomer',
    update: 'updateCustomer',
    create: 'createCustomer',
    get: 'getCustomer'
  },
  mutationKey: 'CUSTOMER',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)

export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  mutations: {
    ...stripeMutations
  },
  actions: {
    ...stripeActions,
    searchCustomers({}, data) {
      const { pagination, search } = data

      const payload = { ...pagination, search }

      return this.$api.post(`/api/customer/search`, payload)
    },
  }
}
